export const PageEnum = {
  // 登录
  BASE_LOGIN: '/login',
  BASE_LOGIN_NAME: 'Login',
  // 首页
  BASE_HOME: '/index',
  BASE_HOME_NAME: 'Index',
  // 错误
  ERROR_PAGE_NAME: 'ErrorPage'
}
